import styled from 'styled-components';

export const Container = styled.div`
  width: 50%;
  align-items: center;
  justify-content: center;
`;